module.exports = __webpack_public_path__ + "img/logo.ffe9256f.svg";